module.exports = __webpack_public_path__ + "static/media/date.4205f30b.svg";